import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import axios from 'axios';
import { Select, Dropdown, Menu, notification } from 'antd';
import { Icon } from 'dlweb-components';
import _ from 'lodash';

const TaskFiles = ({hideModal, task, onFileSelected, user, readOnly}) => {

  const containerRef = useRef(null);

  const [files, setFiles] = useState([]);
  const [selectedFileId, setSelectedFileId] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuDisabled, setMenuDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [menuItems, setMenuItems] = useState([]);

  const angularScopeHook = window.angular.element('#container');
  const angularScope = angularScopeHook.scope();

  useEffect(() => {
    if(!_.isEmpty(task)) {
      setLoading(true);
      axios.post('/api/wt/workflow/dto/file/read', { ...task }).then(
        res => {
          setFiles(res.data.data);
          setLoading(false);
        }
      ).catch(error => {
        alert(`Error loading files.`)
        setLoading(false);
        console.error(error);
      });
    }
    return () => {
      setFiles([]);
      setSelectedFileId(null);
    }
  }, [task])

  useEffect(() => {

    if(files.length > 0) {

      const defaultSelectedId = files[0].fileId;

      setSelectedFileId(defaultSelectedId);
      onFileSelected(defaultSelectedId);
      setMenuDisabled(false);
    }
    else {
      setMenuDisabled(true);
    }
  }, [files, onFileSelected, setMenuDisabled])

  const iconStyle = {
    width: '25px',
    marginRight: '10px'
  }

  const onMenuItemClicked = ({key}) => {

    setLoading(true);
    const fileIdArray = [{ID: selectedFileId}];
    const fileObject = _.find(files, { fileId: selectedFileId });

    const fileService = angularScopeHook.injector().get('File');
    const utilityService = angularScopeHook.injector().get('Utility');
    const locationService = angularScopeHook.injector().get('$location');

    switch (key) {
      case 'navigate':
          const url = utilityService.getLinkURL(selectedFileId);
          locationService.url(url);
          angularScope.$apply();
          hideModal();
        break;
      case 'download':
        fileService.download(fileIdArray, 'download');
        setLoading(false);
        break;
      case 'checkout':
          const checkoutCallback = () => {
            setFiles(f => {
              _.find(f, { fileId: selectedFileId }).checkedOutBy = `<${user}>`;
              return f;
            });
            setLoading(false);
          }

          fileService.download(fileIdArray, 'checkout', checkoutCallback);
        break;
        case 'undoCheckout':
          const undoCallback = () => {
            setFiles(f => {
              _.find(f, { fileId: selectedFileId }).checkedOutBy = '';
              return f;
            });
            setLoading(false);
          }
          
          fileService.undoCheckout(fileIdArray, false, undoCallback);
        break;
      case 'checkin':
        angularScope.closeDialog = () => {
          setLoading(true);
          setFiles(f => {
            _.find(f, { fileId: selectedFileId }).checkedOutBy = '';
            setLoading(false);
            return f;
          })
          onFileSelected(selectedFileId);
        }

         const checkinFile = [
          {
            ID: selectedFileId,
            Status: 'checked out',
            CheckedOutBy: fileObject.checkedOutBy.replace('<', '').replace('>', '')
          }
        ];

        window.launchLegacyDialog('checkin', checkinFile, null, null, null, user);
        setLoading(false);
        break;
      case 'updateProfile':
        angularScope.closeDialog = () => {}
        window.launchLegacyDialog('updateprofile', fileIdArray);
        setLoading(false);
        break;
      case 'redLines':
        setLoading(false);
        break;
      default:
        break;
    }
        
    setMenuVisible(false)
  }

  const onSelect = (fileId) => {
    onFileSelected(fileId);
    setSelectedFileId(fileId);
  }

  useEffect(() => {

    const iconStyle = {
      width: '25px',
      marginRight: '10px'
    }

    if(selectedFileId) {
      const fileObject = _.find(files, { fileId: selectedFileId });

      if(fileObject) {
        var items = [];

        items.push(
          {
            key: 'navigate',
            icon: <Icon type="compass" style={iconStyle}/>,
            label: 'Navigate'
          }
        )

        items.push(
          {
            key: 'download',
            icon: <Icon type="file-download" style={iconStyle}/>,
            label: 'Download'
          }
        )
        
        !readOnly &&
        fileObject.checkedOutBy &&
        items.push(
          {
            key: 'undoCheckout',
            icon: <Icon type="undo" style={iconStyle}/>,
            label: 'Undo Check Out',
            disabled: fileObject.checkedOutBy !== `<${user}>`
          }
        )

        !readOnly &&
        fileObject.checkedOutBy &&
        items.push(
          {
            key: 'checkin',
            icon: <Icon type="file-upload" style={iconStyle}/>,
            label: 'Check In',
            disabled: fileObject.checkedOutBy !== `<${user}>`
          }
        )

        !readOnly &&
        !fileObject.checkedOutBy &&
        items.push(
          {
            key: 'checkout',
            icon: <Icon type="check" style={iconStyle}/>,
            label: 'Check Out'
          }
        )

        !readOnly &&
        items.push(
          {
            key: 'updateProfile',
            icon: <Icon type="pen-square" style={iconStyle}/>,
            label: 'Update Profile'
          }
        )

        setMenuItems(items);
      }
    }
  }, [files, readOnly, user, selectedFileId, loading])

  return (
    <MainContainer ref={containerRef}>
      <TextContainer>
        Document:
      </TextContainer>
      <SelectContainer parentContainer={containerRef}>
        <Select style={{width: "100%"}} value={selectedFileId} onSelect={onSelect} loading={loading} disabled={loading || menuDisabled}>
            {files.map(file => (  
              <Select.Option key={file.fileId} value={file.fileId}>
                {file.checkedOutBy &&
                  <Icon type="check" style={{paddingRight: '10px', color: '#CC3333'}}/>
                }
                {file.fileName}
              </Select.Option>
            ))}
          </Select>

          <Dropdown 
            menu={{items: menuItems, onClick: onMenuItemClicked}}
            trigger={['click']}
            placement="bottomRight"
            disabled={menuDisabled}
          >
            <IconContainer disabled={menuDisabled}>
              <Icon type="ellipsis-h"/>
            </IconContainer>
          </Dropdown>
        </SelectContainer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
 display: flex;
 padding-bottom: 15px;
 background-color: #fff;
`

const TextContainer = styled.div`
  flex: 0 0 68px;
  margin-right: 10px;
  line-height: 32px;
`

const SelectContainer = styled.div`
  flex: 1;
  text-align: initial;
  padding-right: 40px;
`

const IconContainer = styled.div`
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 11px;
  line-height: 30px;
  font-size: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 0 6px 6px 0;
  background-color: ${p => p.disabled ? '#f5f5f5' : '#fff' };
`

export default TaskFiles;
